/**
 * 配置解析器 — 将外部未知输入映射到已验证的 DxfProfile。
 * null / undefined / '' → 默认；已知 ID → 对应配置；其他 → 显式失败。
 */
import { DEFAULT_PROFILE_ID, PROFILES } from './profiles'
import type { DxfProfile, ProfileResolution } from './types'

const profileById: ReadonlyMap<string, DxfProfile> = new Map(
  PROFILES.map((p) => [p.id, p])
)

export function resolveProfile(input: unknown): ProfileResolution {
  if (input == null || input === '') {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { ok: true, profile: profileById.get(DEFAULT_PROFILE_ID)! }
  }

  if (typeof input !== 'string') {
    return { ok: false, reason: 'invalid_profile_id', id: String(input) }
  }

  const profile = profileById.get(input)
  if (profile) {
    return { ok: true, profile }
  }

  return { ok: false, reason: 'invalid_profile_id', id: input }
}

export function getDefaultProfile(): DxfProfile {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return profileById.get(DEFAULT_PROFILE_ID)!
}
